// extracted by mini-css-extract-plugin
module.exports = {"contentList":"index_contentList__TqzbK","inactive":"index_inactive__DaeAJ"};